/* eslint-disable */
import * as React from 'react'
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Grid,
  Paper,
  Modal
} from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import { AutoFixNormal } from '@mui/icons-material'
import { inRange, requestGrammarCheck, sendMessage, startChat } from './util'
import { type ChatMessage, type MessageComponentProps, type Translation } from './model'
import queryString from 'query-string'
import TranslationPopper from './TranslationPopper'
import { getTranslationV2, loadIndexDb } from './translation'
import { type TranslationTable } from './db/tables/translation'

let messages: ChatMessage[] = []

const ChatUIVoiceOnly = (): JSX.Element => {
  const [input, setInput] = React.useState('')
  const [conversationId, setConversationId] = React.useState('')
  const [translationDb, setTranslationDb] = React.useState<TranslationTable | null>(null)

  const [record, setRecord] = React.useState(false)

  const startRecording = () => {
    setRecord(true)
  }

  const stopRecording = () => {
    setRecord(false)
  }

  const onData = (recordedBlob: any) => {
    console.log('chunk of real-time data is: ', recordedBlob)
  }

  const onStop = (recordedBlob: any) => {
    console.log('recordedBlob is: ', recordedBlob)
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setInput(event.target.value)
  }

  const [recording, setRecording] = React.useState(false);
const [mediaRecorder, setMediaRecorder] = React.useState<MediaRecorder | null>(null);

const handleMouseDown = () => {
  navigator.mediaDevices.getUserMedia({ audio: true })
    .then(stream => {
      const newMediaRecorder = new MediaRecorder(stream);
      newMediaRecorder.start();

      newMediaRecorder.ondataavailable = e => {
        // Do something with the audio data here
        console.log(e.data);
      };

      setMediaRecorder(newMediaRecorder);
      setRecording(true);
    });
};

const handleMouseUp = () => {
  if (mediaRecorder) {
    mediaRecorder.stop();
    setRecording(false);
  }
};


  const [loaded, setLoaded] = React.useState(false)
  const [hasLoadingError, setHasLoadingError] = React.useState(false)
  const [loadingErrorMessage, setLoadingErrorMessage] = React.useState('')

  React.useEffect(() => {
    const parsedQuery = queryString.parse(window.location.hash)
    const existingConversationId = parsedQuery['/chat?conversationId']
    console.log(existingConversationId)
    if (Array.isArray(existingConversationId)) {
      setHasLoadingError(true)
      setLoadingErrorMessage('Could not create conversation: multiple conversationId passed as arg')
      setLoaded(true)
      return
    }

    startChat({
      existingConversationId
    }).then(async (response) => {
      messages = response.messages
      setTranslationDb(await loadIndexDb())
      setConversationId(response.conversationId)
      setHasLoadingError(false)
      setLoaded(true)
    }).catch((e) => {
      setHasLoadingError(true)
      setLoadingErrorMessage('Could not create conversation: ' + e)
      setLoaded(true)
    })
  }, [])

  if (hasLoadingError) {
    return (<div>Loading error: {loadingErrorMessage}</div>)
  }
  if (!loaded) {
    return (<div>Still loading</div>)
  }

  return (
        <Box
            sx={{
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              bgcolor: 'grey.200'
            }}
        >
            <Box sx={{ flexGrow: 1, overflow: 'auto', p: 2 }}>
                {messages.map((message) => (
                    <MessageComponent db={translationDb} conversationId={conversationId} key={message.id} message={message} />
                ))}
            </Box>
            <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                    <Button
  variant="contained"
  color="primary"
  onMouseDown={handleMouseDown}
  onMouseUp={handleMouseUp}
>
  {recording ? 'Recording...' : 'Record'}
</Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
  )
}

function MessageComponent (props: MessageComponentProps): JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const words = props.message.message.split(' ').map((word, key) => ({ order: key, word }))
  const [selectedRanges, setSelectedRanges] = React.useState([-1, -1])
  const isBot = props.message.sender === 'bot'
  const [isTranslationOpen, setTranslationOpen] = React.useState(false)

  const [successfullTranslationMap, setSuccessfullTranslationMap] = React.useState(new Map<string, string>())
  const [successfullTranslationMapV2, setSuccessfullTranslationMapV2] = React.useState(new Map<string, Translation[]>())
  const [failedTranslation, setFailedTranslation] = React.useState(new Map<string, string>())
  const [translatedValue, setTranslatedValue] = React.useState('')
  const [translatedList, setTranslatedList] = React.useState<Translation[]>([])

  const handleWordSelection = (key: number, event: React.MouseEvent<HTMLElement>): void => {
    // assume -1, -1 is the initial value when no range has been selected
    // if the selection is out of range, do nothing
    // set the range of the selected words. if they have been unselected, set the start and end range to -1
    // words can only be selected from the immediate left of the start range or the immediate right of the end range.
    // if (selectedRanges[0] === -1 && selectedRanges[1] === -1) {
    //     setSelectedRanges([key, key]);
    //     setTranslationOpen(!isTranslationOpen);
    //     setAnchorEl(anchorEl ? null : event.currentTarget);
    // }

    /*
        scenario 1: no range is currently selected
        action: set the start end end range to the current word

        scenario 2: a range is currently selected and the current word is immediately to the left of the start range
        action: set the start range to the current word

        scenario 3: a range is currently selected and the current word is immediately to the right of the end range
        action: set the end range to the current word

        scenario 4: a range is currently selected and is equal to the current word
        action: set the start and end range to -1 (unselect the range)

        senario 5: a range is currently selected and the is currently selected and the current word is neither immediately to the left of the start range nor immediately to the right of the end range
        action: set the start and end range to the current word

        */
    let startRange = selectedRanges[0]
    let endRange = selectedRanges[1]
    if (startRange === -1 && endRange === -1) {
      // Scenario 1: No range is currently selected
      startRange = key
      endRange = key
      setTranslationOpen(true)
    } else if (key === startRange) {
      // Scenario 4: Range is currently selected and equal to the current word
      startRange = -1
      endRange = -1
      setTranslationOpen(false)
    } else if (key === startRange - 1) {
      // Scenario 2: Range is currently selected and the current word is immediately to the left of the start range
      startRange = key
      setTranslationOpen(true)
    } else if (key === endRange + 1) {
      // Scenario 3: Range is currently selected and the current word is immediately to the right of the end range
      endRange = key
      setTranslationOpen(true)
    } else {
      // Scenario 5: Range is currently selected and the current word is neither immediately to the left of the start range nor immediately to the right of the end range
      startRange = key
      endRange = key
      setTranslationOpen(true)
    }

    if (startRange !== -1 && endRange !== -1 && startRange === endRange) {
      // call getTranslation with words[startRange] through words[endRange]
      // const selectedWords = words.slice(startRange, endRange + 1).map((word) => word.word);
      if (!successfullTranslationMap.has(words[startRange].word) && !failedTranslation.has(words[startRange].word)) {
        getTranslationV2({
          conversationId: props.conversationId,
          phrase: [words[startRange].word]
        }, props.db).then((translationres) => {
          console.log('translation result: ')
          console.log(translationres)
          let translationMessage = translationres.responseMessage
          if (translationMessage === '') {
            translationMessage = 'No translation found'
          }
          const newMap = new Map(successfullTranslationMap)
          newMap.set(words[startRange].word, translationMessage)
          setSuccessfullTranslationMap(newMap)

          // v2
          const newMapV2 = new Map(successfullTranslationMapV2)
          newMapV2.set(words[startRange].word, translationres.translations ?? [])
          setSuccessfullTranslationMapV2(newMapV2)
          console.log(translationres.translations)

          setTranslatedValue(translationres.responseMessage)
          setTranslatedList(translationres.translations ?? [])
        }).catch((error) => {
          const translationMessage = 'Translation failed: ' + error
          const newMap = new Map(failedTranslation)
          newMap.set(words[startRange].word, translationMessage)
          setFailedTranslation(newMap)
          setTranslatedValue(translationMessage)
          setTranslatedList([])
        })
      } else {
        setTranslatedValue(successfullTranslationMap.get(words[startRange].word) ?? failedTranslation.get(words[startRange].word) ?? '')
        setTranslatedList(successfullTranslationMapV2.get(words[startRange].word) ?? [])
      }
    } else {
      setTranslatedValue('')
    }

    setSelectedRanges([startRange, endRange])
    setAnchorEl(event.currentTarget)
  }

  const [grammarCheckResult, setGrammarCheckResult] = React.useState('Loading...')
  const [grammarCheckExists, setGrammarCheckExists] = React.useState(false)

  const handleGrammarCheck = (): void => {
    setGrammarCheckOpen(true)
    if (grammarCheckExists) {
      return
    }

    requestGrammarCheck(props.conversationId, props.message.message, props.message.id).then((result) => {
      setGrammarCheckResult(result.responseMessage)
      setGrammarCheckExists(true)
    }).catch((error) => {
      setGrammarCheckResult('Error fecching grammar check: ' + error)
      setGrammarCheckExists(true)
    })
  }

  const [grammarCheckOpen, setGrammarCheckOpen] = React.useState(false)

  const handleGrammarCheckClose = (): void => { setGrammarCheckOpen(false) }
  return (
        <>
                <Box
                    sx={{
                      display: 'flex',
                      justifyContent: isBot ? 'flex-start' : 'flex-end',
                      mb: 2
                    }}
            >
                <Box
                    sx={{
                      display: 'flex',
                      flexDirection: isBot ? 'row' : 'row-reverse',
                      alignItems: 'center'
                    }}
                >
                    <Avatar sx={{ bgcolor: isBot ? 'primary.main' : 'secondary.main' }}>
                        {isBot ? 'B' : 'U'}
                    </Avatar>
                    <TranslationPopper isTranslationOpen={isTranslationOpen} anchorEl={anchorEl} translatedValue={translatedValue} translations={translatedList}></TranslationPopper>

                    <Modal
            open={grammarCheckOpen}
            onClose={handleGrammarCheckClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
                <Box sx={{
                  position: 'absolute' as 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 400,
                  bgcolor: 'background.paper',
                  border: '2px solid #000',
                  boxShadow: 24,
                  p: 4
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                    Grammar Check
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {grammarCheckResult.split('\n').map((item, key) => (
                    <React.Fragment key={key}> <span key={key}>{item}</span>  <br/> </React.Fragment>))
                    }
                    </Typography>
                </Box>
            </Modal>
                        <Paper
                            variant="outlined"
                            sx={{
                              whiteSpace: 'normal',
                              p: 2,
                              ml: isBot ? 1 : 0,
                              mr: isBot ? 0 : 1,
                              color: 'white',
                              backgroundColor: isBot ? 'primary.light' : 'secondary.light',
                              borderRadius: isBot ? '20px 20px 20px 5px' : '20px 20px 5px 20px'
                            }}
                        >

                            <Typography id="chat-msg-body" variant="body1" sx={{ whiteSpace: 'normal' }}>
                                {words.map((item, key) => (
                                    <React.Fragment key={key}>
                                        <span onClick={(event) => {
                                          handleWordSelection(key, event)
                                        }} style={{
                                          userSelect: 'none',
                                          display: 'inline-block',
                                          border: inRange(key, selectedRanges) ? '1px solid black' : 'none'
                                        }}>
                                            {item.word}
                                        </span>
                                        &nbsp;
                                    </React.Fragment>
                                ))}
                            </Typography>

                        </Paper>

          {!isBot && <Button size="small" onClick={handleGrammarCheck}><AutoFixNormal fontSize="small" /></Button> }

                </Box>
            </Box >
        </>
  )
};

export default ChatUIVoiceOnly
